(() => {
  const rootSelector = '[data-tradepro-load-more-root]';
  const buttonSelector = '[data-tradepro-load-more-button]';

  const init = (root) => {
    const grid = root.querySelector('.tradepro-collection-grid');
    const control = root.querySelector('[data-tradepro-load-more]');
    const button = root.querySelector(buttonSelector);
    const pagination = root.querySelector('[data-tradepro-pagination]');
    const status = root.querySelector('[data-tradepro-load-more-status]');
    const label = root.querySelector('[data-tradepro-load-more-label]');
    if (!grid || !control || !button || button.dataset.tradeproLoadMoreReady === 'true') return;

    button.dataset.tradeproLoadMoreReady = 'true';
    if (pagination) pagination.hidden = true;

    button.addEventListener('click', async () => {
      const nextUrl = button.dataset.nextUrl;
      if (!nextUrl) { control.hidden = true; return; }

      const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
      button.disabled = true;
      if (label) label.textContent = button.dataset.loadingLabel || defaultLabel;
      if (status) status.textContent = '';

      try {
        const response = await fetch(nextUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = documentNext.querySelector(rootSelector);
        const nextGrid = nextRoot ? nextRoot.querySelector('.tradepro-collection-grid') : null;
        const nextButton = nextRoot ? nextRoot.querySelector(buttonSelector) : null;
        if (!nextGrid) throw new Error('Next collection grid was not found.');

        const items = Array.from(nextGrid.children);
        if (!items.length) { control.hidden = true; return; }
        const fragment = document.createDocumentFragment();
        items.forEach((item) => fragment.appendChild(item));
        grid.appendChild(fragment);

        const followingUrl = nextButton ? nextButton.dataset.nextUrl : '';
        if (followingUrl) {
          button.dataset.nextUrl = followingUrl;
          if (label) label.textContent = defaultLabel;
          button.disabled = false;
        } else {
          control.hidden = true;
        }
      } catch (error) {
        console.error('TradePro collection Load more failed:', error);
        button.disabled = false;
        if (label) label.textContent = defaultLabel;
        if (status) status.textContent = button.dataset.errorLabel || defaultLabel;
        if (pagination) pagination.hidden = false;
      }
    });
  };

  const initialize = () => document.querySelectorAll(rootSelector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();